import TrainingVideo from './TrainingVideo';

export default TrainingVideo;
